
// import React from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import logo from "../assets/nccflogo.jpg"; // Adjust the path if needed

// function Sidebar() {
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     localStorage.removeItem('user');
//     navigate('/');
//   };

//   return (
//     <div className="w-64 h-screen bg-blue-900 text-white p-6 fixed flex flex-col justify-between shadow-lg">
//       {/* Logo and Title */}
//       <div>
//         <div className="flex items-center mb-10">
//           <img
//             src={logo}
//             alt="NCCF Logo"
//             className="w-12 h-12 rounded-full object-cover mr-3 border border-white"
//           />
//           <h2 className="text-2xl font-bold">NCCF</h2>
//         </div>

//         {/* Navigation Links */}
//         <nav className="flex flex-col space-y-4">
//           <Link
//             to="/dashboard"
//             className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200"
//           >
//             Dashboard
//           </Link>
//           <Link
//             to="/uploadProcurement"
//             className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200"
//           >
//             Upload Procurement
//           </Link>
//           <Link
//             to="/uploadStock"
//             className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200"
//           >
//             Upload Stock
//           </Link>
//           <Link
//             to="/procurementList"
//             className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200"
//           >
//             Procurement List
//           </Link>
//           <Link
//             to="/stockList"
//             className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200"
//           >
//             Stock List
//           </Link>
//         </nav>
//       </div>

//       {/* Logout Button */}
//       <button
//         onClick={handleLogout}
//         className="mt-6 bg-red-500 hover:bg-red-600 px-4 py-2 rounded text-white transition duration-200"
//       >
//         Logout
//       </button>
//     </div>
//   );
// }

// export default Sidebar;


import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from "../assets/nccflogo.jpg";

function Sidebar() {
  const navigate = useNavigate();

  // Get user role from localStorage
  const user = JSON.parse(localStorage.getItem('user'));
  const role = user?.role || 'user';

  const handleLogout = () => {
    localStorage.removeItem('user');
    // localStorage.removeItem('userRole');
    // localStorage.removeItem('isLoggedIn');
    // localStorage.removeItem('access_token');
    navigate('/');
  };

  return (
   <div className="w-64 h-screen bg-blue-900 text-white p-6 flex flex-col justify-between shadow-lg fixed md:static">
      {/* Logo and Title */}
      <div>
        <div className="flex items-center mb-10">
          <img
            src={logo}
            alt="NCCF Logo"
            className="w-12 h-12 rounded-full object-cover mr-3 border border-white"
          />
          <h2 className="text-2xl font-bold">NCCF</h2>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-col space-y-4">
          {role === 'admin' && (
            <>
              <Link to="/dashboard" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Dashboard
              </Link>
              <Link to="/uploadProcurement" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Upload Procurement
              </Link>
              <Link to="/uploadStock" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Upload Stock
              </Link>
              <Link to="/procurementList" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Procurement List
              </Link>
              <Link to="/stockList" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Stock List
              </Link>
              <Link to="/transactions" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Pending Procurement
              </Link>
              <Link to="/approvedtransaction" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Approved Procurement
              </Link>
              <Link to="/pendingstock" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Pending Stock
              </Link>
               <Link to="/approvedstock" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Approved Stock
              </Link>
            </>
          )}

          {role === 'user' && (
            <>
            <Link to="/transactions" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
              Pending Procurement
            </Link>
             <Link to="/approvedtransaction" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Approved Procurement
              </Link>
              <Link to="/pendingstock" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Pending Stock
              </Link>
               <Link to="/approvedstock" className="bg-blue-800 hover:bg-blue-700 px-4 py-2 rounded transition duration-200">
                Approved Stock
              </Link>
            </>
            
            
          )}
        </nav>
      </div>

      {/* Logout Button */}
      <button
        onClick={handleLogout}
        className="mt-6 bg-red-500 hover:bg-red-600 px-4 py-2 rounded text-white transition duration-200"
      >
        Logout
      </button>
    </div>
  );
}

export default Sidebar;
